// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SetInterestOnlyPaymentsCheckbox: 'set-interest-only-payments-checkbox',
	MaturityDateDatePicker: 'maturity-date-date-picker',
	PrincipalAmount: 'principal-amount',
	Term: 'term',
	PrimeRate: 'prime-rate',
	Input: 'input',
	RegularPayments: 'regular-payments',
	InterestRateTypeRadioGroup: 'interest-rate-type-radio-group',
	SetAbovePrimeRadioGroup: 'set-above-prime-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
